import React from "react";
import Editor from "react-simple-code-editor";
import Prism from "prismjs";
import "prismjs/components/prism-markup";
import "./html-code-editor.css";

// Highlight {{variables}} on top of HTML markup so they stand out like an IDE.
if (Prism.languages.markup && !Prism.languages.markup.mustache) {
  Prism.languages.insertBefore("markup", "tag", {
    mustache: { pattern: /\{\{\s*[\w.]+\s*\}\}/, alias: "mustache", greedy: true },
  });
}

const highlight = (code) => Prism.highlight(code || "", Prism.languages.markup, "markup");

export default function HtmlCodeEditor({ value, onChange, disabled, testId }) {
  return (
    <div className="hce-wrap" data-testid={testId}>
      <Editor
        value={value || ""}
        onValueChange={(v) => !disabled && onChange(v)}
        highlight={highlight}
        readOnly={disabled}
        padding={14}
        spellCheck={false}
        className="hce-editor"
        textareaClassName="hce-textarea"
        preClassName="hce-pre"
      />
    </div>
  );
}
